import styled from "styled-components";

export const SplitLayoutStyled = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
`;

// Left column — the Skills / Courses tabs panel. A flex column whose antd
// Tabs is stretched to the panel's full height, so the Skills pane can hand
// its skill list the whole vertical run down to the bottom of the page.
// Without this the list has no bounded parent to size against and has to
// fall back on a fixed height, which stops it short of the Individual
// Profile Summary card in the column beside it.
//
// antd v6 Tabs DOM: .ant-tabs > .ant-tabs-nav + .ant-tabs-body-holder >
// .ant-tabs-body > .ant-tabs-content (one per pane; -active marks the
// visible one — v5's content-holder/tabpane classes no longer exist, so
// overrides written against those names silently match nothing). Same
// override set as ViewPlanningV2.styles.js's TabsBodyStyled.
export const RightPanelStyled = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 0;
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .ant-tabs {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
  }

  .ant-tabs-nav {
    flex-shrink: 0;
  }

  .ant-tabs-body-holder,
  .ant-tabs-body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .ant-tabs-content {
    height: 100%;
    min-height: 0;
  }

  .ant-tabs-content-active {
    display: flex;
    flex-direction: column;
  }
`;

// Rightmost column — candidate details on top, "Individual Profile Summary"
// below, mirroring SkillsBridger's own EmployeeSkillsMapV2 layout (skill
// chart + this column side by side). Sits to the right of the Skills/Courses
// tabs panel (which contains the skill bar graph).
export const ProfileSummaryColumnStyled = styled.div`
  width: 480px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px 16px 20px;
  border-left: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
  overflow-y: auto;
`;

export const CourseRowStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid ${(p) => p.theme?.colors?.borderLight ?? "#E5E7EB"};
  font-size: 12.5px;

  .name { font-weight: 600; }
  .meta { color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"}; font-size: 11.5px; }
`;

export const ProgressTrackStyled = styled.div`
  width: 120px;
  height: 6px;
  border-radius: 3px;
  background: ${(p) => p.theme?.colors?.borderLight ?? "#E5E7EB"};
  overflow: hidden;
`;

export const ProgressFillStyled = styled.div`
  height: 100%;
  width: ${(p) => Math.min(100, Math.max(0, p.$pct ?? 0))}%;
  background: ${(p) => p.theme?.colors?.primary ?? "#008080"};
`;

// Mirrors SkillsBridger's own "Skills Proficiency / Skills Map" dropdown
// trigger (GroupPageHeader's RightDropdownTriggerStyled) — sits top-right of
// the skill bar graph.
export const SkillsViewHeaderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
  flex-shrink: 0;
`;

// The Skills tab's own body — a flex column, so the header row above stays
// pinned and SkillGapList's fillHeight box absorbs whatever height is left.
// The SbSpin around the list wraps it in two divs of its own; both have to
// be flexed through as well, or the list's flex: 1 has nothing to resolve
// against and collapses to its content height.
//
// antd v6 spin DOM: .ant-spin > .ant-spin-container (v5's
// .ant-spin-nested-loading wrapper is gone) — same naming ViewPlanningV2
// notes for its table's spin layers.
export const SkillsPaneStyled = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  > .ant-spin,
  > .ant-spin > .ant-spin-container {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
`;

// Skills Map view — the bubble chart draws at its own intrinsic size, so it
// gets a scroll box rather than the flex-fill the gap list uses.
export const SkillsMapScrollStyled = styled.div`
  flex: 1;
  min-height: 0;
  overflow: auto;
`;

export const SkillsViewDropdownTriggerStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
  cursor: pointer;
`;
